<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <keep-alive :include="['SupportPcIndex']">
        <component :is="Component" :key="getComponentKey()" v-wechat-title="$route.meta.title" />
      </keep-alive>
    </router-view>
    <jl-loading id="jl-loading" v-if="projectType === 'support'" backgroundColor="" type="circular" color="#0390FF" />
    <jl-loading id="jl-loading" v-else />
  </div>
  <CustomNotify />
</template>

<script setup>
import jlLoading from '@/components/jl_loading.vue'
import CustomNotify from '@/components/jl_notify.vue'
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { getProjectType } from '@/assets/js/common'

const projectType = ref(getProjectType())
const route = useRoute()

// 为support项目生成稳定的key
const getComponentKey = () => {
  if (projectType.value === 'support') {
    // 对于support项目，使用路径的前三段作为key，避免子路由切换时重新渲染
    const pathParts = route.path.split('/').filter((part) => part) // 过滤空字符串
    if (pathParts.length >= 2) {
      return `/${pathParts[0]}/${pathParts[1]}` // 例如: /merch/pc
    }
  }
  return route.name
}
</script>

<style lang="less">
@import url('./assets/css/vant.css');
@import url('./assets/css/reset.css');

html,
body {
  background-color: #f5f5f5;
  color: #333333;
}
#app {
  height: 100%;
}

#jl-loading {
  display: none;
}
</style>
